import { findInputParent } from "./helpers";

export default function() {
  const inputs = document.querySelectorAll(".js-input, .js-textarea");
  const forms = document.querySelectorAll(".js-form");

  if (!inputs.length) return;

  function handleErrorMessage(_input) {
    const parent = findInputParent(_input);
    const errorNode = parent.querySelector(".js-input-error");
    errorNode.innerHTML = _input.validationMessage ? `<span class="cs-visually-hidden">${_input.labels[0]?.innerText}: </span>` + _input.validationMessage : ""; 
  }

  function showError(_input) {
    _input.classList.add("js-input--invalid");
    const parent = findInputParent(_input);
    parent.classList.add("js-input-container--error");
    _input.setAttribute("aria-invalid", "true");
  }

  function hideError(_input) {
    _input.classList.remove("js-input--invalid");
    const parent = findInputParent(_input);
    parent.classList.remove("js-input-container--error");
    _input.setAttribute("aria-invalid", "false");
  }

  function showErrorOnBlur() {
    showError(this);
  }

  function hideErrorOnInput() {
    hideError(this);

    this.removeEventListener("blur", showErrorOnBlur);
  }

  function setInputError(_input) {
    _input.addEventListener("blur", showErrorOnBlur);
    _input.addEventListener("input", hideErrorOnInput);
  }

  function resetInputError(_input) {
    hideError(_input);
    _input.removeEventListener("blur", showErrorOnBlur);
    _input.removeEventListener("input", hideErrorOnInput);
  }

  function detectError(_input) {
    handleErrorMessage(_input);

    if (_input.validity.valid) {
      resetInputError(_input);
    } else {
      setInputError(_input);
    }
  }

  function onChangeErrorHandler() {
    detectError(this);
  }

  function handleCheckboxErrorMessage(_input) {
    const parent = findInputParent(_input);
    const errorNode = parent.querySelector(".js-input-error");
    errorNode.textContent = errorNode.dataset.error || "";
  }

  function detectCheckboxError(_input) {
    if (!_input.checked) {
      handleCheckboxErrorMessage(_input);
      showError(_input);
    } else {
      hideError(_input);
    }
  }

  function onCheckboxChangeErrorHandler() {
    detectCheckboxError(this)
  }

  function onFormResetErrorHandler() {
    const resetInputs = this.querySelectorAll(".js-input");

    for (let i = 0; i < resetInputs.length; i++) {
      const resetInput = resetInputs[i];
      
      setTimeout(function() {
        resetInputError(resetInput);

        if (resetInput.type !== "checkbox") {
          detectError(resetInput);
        }
      }, 0);
    }
  }

  function onContentLoadedInputErrorHandler() {
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];

      if (input.type === "checkbox") {
        input.addEventListener("change", onCheckboxChangeErrorHandler);

      } else {
        detectError(input);

        if (input.type === "number") {
          // Cover cases when the browser doesn't fire onchange event if the value of input is invalid, but this value is visually presented (Firefox behavior).
          input.addEventListener("input", onChangeErrorHandler);
        } else {
          input.addEventListener("change", onChangeErrorHandler);
        }
      }
    }

    for (let i = 0; i < forms.length; i++) {
      const form = forms[i];

      form.addEventListener("reset", onFormResetErrorHandler, false);
    }
  }

  window.addEventListener("DOMContentLoaded", onContentLoadedInputErrorHandler);
}
